import { call, put, takeEvery } from "redux-saga/effects";
import { loaiGioHocApi } from "../../../api/category/loaiGioHocApi";
import { ILoaiGioHoc } from "../../../model/respone/category/ILoaiGioHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eLoaiGioHocActionIds,
  ILoaiGioHocActionTypes,
} from "../../action-types/category/ILoaiGioHocActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.loaiGioHoc;

export function* loaiGioHocSaga(): any {
  yield takeEvery(eLoaiGioHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eLoaiGioHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eLoaiGioHocActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(loaiGioHocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: ILoaiGioHocActionTypes): any {
  const payload = action.payload as ILoaiGioHoc;
  let res: IBaseRespone;
  if (payload.id > 0) {
    res = yield call(loaiGioHocApi.Update, payload);
  } else {
    res = yield call(loaiGioHocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: ILoaiGioHocActionTypes): any {
  const res: IBaseRespone = yield call(loaiGioHocApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
